import { Skeleton, TableFooter, TableRow, TableCell } from "@mui/material";
import useGrandTotal from "../../hooks/useGrandTotal";
import { NumberField, RecordContextProvider, TextField } from "react-admin";

const InventoryCardFooterList = ({ canSeeCompanyColumn = false }) => {
  const { data, isLoading } = useGrandTotal();

  // if (error) return <Error />;

  return (
    <RecordContextProvider value={data ? data[0] : {}}>
      <TableFooter>
        <TableRow
          sx={{
            "& td": {
              borderTop: "1px solid rgba(224, 224, 224, 1) !important",
            },
            "& .MuiTypography-root": {
              color: (theme) => theme.palette.primary.main,
              fontWeight: "bold",
            },
          }}
        >
          <TableCell />
          {canSeeCompanyColumn ? <TableCell /> : null}
          <TableCell>
            <RecordContextProvider value={{ name: "GRAND TOTAL" }}>
              <TextField source="name" />
            </RecordContextProvider>
          </TableCell>
          <TableCell sx={{ textAlign: "right" }}>
            {isLoading ? <Skeleton /> : <NumberField source="initial" textAlign="right" />}
          </TableCell>
          <TableCell sx={{ textAlign: "right" }}>
            {isLoading ? <Skeleton /> : <NumberField source="initial_value" textAlign="right" />}
          </TableCell>
          <TableCell sx={{ textAlign: "right" }}>
            {isLoading ? <Skeleton /> : <NumberField source="total_in" textAlign="right" />}
          </TableCell>
          <TableCell sx={{ textAlign: "right" }}>
            {isLoading ? <Skeleton /> : <NumberField source="total_in_value" textAlign="right" />}
          </TableCell>
          <TableCell sx={{ textAlign: "right" }}>
            {isLoading ? <Skeleton /> : <NumberField source="total_out" textAlign="right" />}
          </TableCell>
          <TableCell sx={{ textAlign: "right" }}>
            {isLoading ? <Skeleton /> : <NumberField source="total_out_value" textAlign="right" />}
          </TableCell>
          <TableCell sx={{ textAlign: "right" }}>
            {isLoading ? <Skeleton /> : <NumberField source="other" textAlign="right" />}
          </TableCell>
          <TableCell sx={{ textAlign: "right" }}>
            {isLoading ? <Skeleton /> : <NumberField source="other_value" textAlign="right" />}
          </TableCell>
          <TableCell sx={{ textAlign: "right" }}>
            {isLoading ? <Skeleton /> : <NumberField source="final" textAlign="right" />}
          </TableCell>
          <TableCell sx={{ textAlign: "right" }}>
            {/* empty HPP cell for alignment with list columns */}
          </TableCell>
          <TableCell sx={{ textAlign: "right" }}>
            {isLoading ? <Skeleton /> : <NumberField source="final_value" textAlign="right" />}
          </TableCell>
        </TableRow>
      </TableFooter>
    </RecordContextProvider>
  );
};

export default InventoryCardFooterList;
